// @flow
import type { State } from '../types';

const subStateSelector = (state: State) => state.user;

export const isLoadingSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.status.isLoading;
};

export const initializedSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.initialized;
};

export const isLoggedInSelector = (state: State) => {
    const subState = subStateSelector(state);
    return Boolean(subState.value);
};

export const nameSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.value && subState.value.name;
};